export const Width = {
  XS: 400,
  SM: 600,
  MD: 900,
  LG: 1500,
};
